import { useRef } from 'react';
import styles from './buttonStyles.module.css';

export const NewFolderModal = ({ handleOnchange, setModalIsOpen, postFileOrFolder, handleOpenModal }) => {
    const addBtnRef = useRef(null);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            postFileOrFolder();
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#fff3e0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>
                    📁
                </div>
                <div>
                    <div style={{ fontSize: 17, fontWeight: 700, color: '#2d3748', lineHeight: 1.2 }}>New Folder</div>
                    <div style={{ fontSize: 12, color: '#718096', marginTop: 2 }}>Name your folder</div>
                </div>
            </div>

            <input
                style={{ width: '100%', padding: '10px 12px', border: '2px solid #c5cae9', borderRadius: 8, outline: 'none', fontSize: 14, color: '#2d3748', boxSizing: 'border-box', marginBottom: '20px' }}
                type="text"
                placeholder="folder name"
                autoFocus
                onChange={handleOnchange}
                onKeyDown={handleKeyDown}
            />

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                <button className={styles.cancle} onClick={() => { setModalIsOpen(false); handleOpenModal(false); }}>Cancel</button>
                <button ref={addBtnRef} className={styles.sucess} onClick={() => { postFileOrFolder(); }}>Add</button>
            </div>
        </div>
    );
};
